export const adaptFormName = (arrayForm, formName) => {
    let formattedData = {};
    arrayForm.map((e) => {
        formattedData[e.name.replace(formName + '[', '').replace(']', '')] = e.value;
    });
    return formattedData;
};

export const submitPrint = function (data, callFunction, url) {
    var print = adaptFormName($('form[name=print]').serializeArray(), 'print');
    callFunction.startLoading();
    $.post(url, {print, data}, function (rep) {
        callFunction.stopLoading();
        if (rep.status === 500) {
            return callFunction.addUnknowError();
        }
        if (typeof rep.valid !== 'undefined' && rep.valid === true) {
            callFunction.addGlobalSuccess('Document(s) envoyé(s) à l\'imprimante');
            callFunction.addReloadButton();
        } else {
            callFunction.modalBody.innerHTML = rep.template;
        }
    });
};

export const submitDenonce = function (data, callFunction, url) {
    var denonce = adaptFormName($('form[name=denonce]').serializeArray(), 'denonce');
    callFunction.startLoading();
    $.post(url, {denonce, data}, function (rep) {
        callFunction.stopLoading();
        if (rep.status === 500) {
            return callFunction.addUnknowError();
        }
        if (typeof rep.valid !== 'undefined' && rep.valid === true) {
            callFunction.addGlobalSuccess('Document(s) envoyé(s) à l\'imprimante');
            callFunction.addReloadButton();
        } else {
            callFunction.modalBody.innerHTML = rep.template;
        }
    });
};

export const submitMemo = function (data, callFunction, url) {
    var send_memo = adaptFormName($('form[name=send_memo]').serializeArray(), 'send_memo');
    callFunction.startLoading();

    $.post(url, {send_memo, data}, function (rep) {
        callFunction.stopLoading();
        if (rep.status === 500) {
            return callFunction.addUnknowError();
        }
        if (rep.success) {
            let docEntryActivity = rep.docEntryActivity
            callFunction.addGlobalSuccess('Activité en cours de création');
            window.location.reload();
            openForm('OCLG', docEntryActivity[0].toString())
        } else {
            callFunction.modalBody.innerHTML = rep.template;
        }
    });
};

export const createBSModal = (id,title,htmlBody,htmlFooter) => {
    let divContainer = document.createElement('div'),
        divDialog = document.createElement('div'),
        divContent = document.createElement('div'),
        divHeader = document.createElement('div'),
        divBody = document.createElement('div'),
        h5Title = document.createElement('h5'),
        btnClose = document.createElement('button'),
        spanClose = document.createElement('span');

    divContainer.className = 'modal';
    divContainer.id = id;
    divContainer.setAttribute('tabindex','-1');
    divContainer.setAttribute('role','dialog');
    divDialog.className = 'modal-dialog';
    divDialog.setAttribute('role','document');
    divContent.className = 'modal-content';
    divHeader.className = 'modal-header';
    divBody.className = 'modal-body';
    divBody.innerHTML = htmlBody;
    h5Title.className = 'modal-title';
    h5Title.innerHTML = title;
    spanClose.setAttribute('aria-hidden','true');
    spanClose.innerHTML = '&times;';
    btnClose.type = 'button';
    btnClose.className = 'close';
    btnClose.setAttribute('data-dismiss','modal');
    btnClose.setAttribute('aria-label','Close');
    btnClose.appendChild(spanClose);
    divHeader.appendChild(h5Title);
    divHeader.appendChild(btnClose);
    divContent.appendChild(divHeader);
    divContent.appendChild(divBody);

    if(htmlFooter != undefined){
        let divFooter = document.createElement('div');
        divFooter.className = 'modal-footer';
        divFooter.innerHTML = htmlFooter;
        divContent.appendChild(divFooter);
    }
    divDialog.appendChild(divContent);
    divContainer.appendChild(divDialog);
    return divContainer;
};

export const createAlert = (color, message, icon) => {
    let div = document.createElement('div'),
        i = document.createElement('i');
    div.className = 'alert alert-' + color;
    i.className = icon;
    div.appendChild(i);
    div.innerText = message;
    return div;
};

export const createSelectCheckbox = (id, value, labelText) => {
    let div = document.createElement('div'),
        checkboxLabel = document.createElement('label'),
        input = document.createElement('input'),
        checkboxSpan = document.createElement('span'),
        label = document.createElement('label');

    div.className = 'd-flex my-2';
    checkboxLabel.className = 'checkbox-label mx-2';
    checkboxSpan.className = 'checkbox-custom rectangular';
    input.type = 'checkbox';
    input.id = id;
    input.value = value;
    input.dataset.checkboxPrint = "";

    label.for = id;
    label.className = 'form-check-label ml-2 mt-1';
    label.innerText = labelText;
    checkboxLabel.appendChild(input);
    checkboxLabel.appendChild(checkboxSpan);
    div.appendChild(checkboxLabel);
    div.appendChild(label);
    return div;
};

export const createSelect = (label, options, id, classContainer) => {

    let labelElement = document.createElement('label'),
        container = document.createElement('div'),
        select = document.createElement('select');

    labelElement.innerText = label;
    labelElement.className = 'mr-2';
    labelElement.for = id;
    select.className = 'form-control';
    select.id = 'printer';
    container.className = (classContainer !== undefined) ? classContainer : 'form-group';

    for (let [label, value] of Object.entries(options)) {
        let option = document.createElement('option');
        option.value = value;
        option.innerText = label;
        select.appendChild(option);
    }

    container.appendChild(labelElement);
    container.appendChild(select);
    return container;
};

export const createBadge = (color, text, id = null) => {
    let span = document.createElement('span');
    span.className = 'm-1 badge badge-' + color;
    span.innerText = text;

    if (id) span.id = id;

    return span;
};

export const disableButton = (obj, disable = false) => {
    let loader = document.createElement('i');
    loader.className = 'fad fa-spinner-third fa-spin';
    obj.innerHTML = '';
    obj.appendChild(loader);
    obj.disabled = disable;
};

export const createButton = (btnClassName, btnText, iconClassName) => {
    let btn = document.createElement('button');
    btn.setAttribute('type', 'button');
    btn.className = btnClassName;
    if (iconClassName !== "") {
        btn.appendChild(createIcon(iconClassName));
    }
    if (btnText !== ""){
        btn.innerText = btnText;
    }
    return btn;
};

export const createIcon = (iconClassName) => {
    let icon = document.createElement('i');
    icon.className = iconClassName;
    return icon;
};

export const addFeedback = (inputContainerElement, valid, message) => {
    let feedback = document.createElement('div'),
        input = inputContainerElement.querySelector('input');
    input.className = input.className + ' is-' + valid;
    feedback.className = valid + '-feedback';
    feedback.innerText = typeof message !== "undefined" ? message : null;
    return inputContainerElement.appendChild(feedback);
};

export const removeFeedback = (inputContainerElement) => {
    for (let i = 0; i < inputContainerElement.children.length; i++) {
        let element = inputContainerElement.children[i];
        if (element.className.indexOf('feedback') !== -1) {
            element.remove();
        }
        if (element.className.indexOf('is-invalid')) {
            element.className = element.className.replace("is-invalid", "");
        }
    }
};

export const createElement = (tagName, className) => {
  let element = document.createElement(tagName);
  element.className = className;
  return element;
};

export const htmlStringToElement = (string) => {
    let template = document.createElement('template');
    string = string.trim();
    template.innerHTML = string;
    return template.content.firstChild;
};

export const removeAllChild = (e) => {
    while (e.firstChild){
        e.removeChild(e.firstChild);
    }
};
export const isObject = (value) => typeof value === "object";

export function isPlainObject(value) {
    if (!isObject(value)) {
        return false;
    }

    try {
        const { constructor } = value;
        const { prototype } = constructor;

        return constructor && prototype && hasOwnProperty.call(prototype, 'isPrototypeOf');
    } catch (error) {
        return false;
    }
}

export const assign = Object.assign || function assign(obj, ...args) {
    if (isObject(obj) && args.length > 0) {
        args.forEach((arg) => {
            if (isObject(arg)) {
                Object.keys(arg).forEach((key) => {
                    obj[key] = arg[key];
                });
            }
        });
    }

    return obj;
};


// WEBPACK FOOTER //
// ./assets/js/utils_element.js